import React from 'react';
import { Outlet } from 'react-router-dom';
import { useMobile } from '../../../app/hooks/useMobile';
import { AsideDefault } from './aside/AsideDefault';
import { Footer } from './Footer';
import { HeaderWrapper } from './header/HeaderWrapper';
import { RightToolbar } from '../../partials/layout/RightToolbar';
import { ScrollTop } from './ScrollTop';
import { Content } from './Content';
import { PageDataProvider } from '../core';
import { ActivityDrawer, DrawerMessenger, InviteUsers, UpgradePlan } from '../../partials';
import { MobileGridNavigation } from './mobile/MobileGridNavigation';

const ResponsiveLayoutWrapper: React.FC = () => {
  const isMobile = useMobile();

  if (isMobile) {
    // Mobile Layout: Header + Profile + Grid + Content
    return (
      <PageDataProvider>
        <div className='mobile-layout d-flex flex-column'>
          {/* Mobile Header - Keep logo/branding */}
          <HeaderWrapper />
          
          {/* Mobile Profile Section - User info under logo */}
          {/* <div className='mobile-profile-section'>
          </div> */}
          
          {/* Mobile Grid Navigation */}
          <MobileGridNavigation />
          
          {/* Mobile Content Area */}
          <div className='mobile-content flex-grow-1'>
            <Content>
              <Outlet />
            </Content>
          </div>
        </div>

        {/* Mobile-specific modals */}
        <InviteUsers />
        <UpgradePlan />
        <ScrollTop />
      </PageDataProvider>
    );
  }

  // Desktop Layout: Keep original structure
  return (
    <PageDataProvider>
      <div className='page d-flex flex-row flex-column-fluid'>
        <AsideDefault />
        <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
          <HeaderWrapper />

          <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
            <div className='post d-flex flex-column-fluid' id='kt_post'>
              <Content>
                <Outlet />
              </Content>
            </div>
          </div>
          <Footer />
        </div>
      </div>

      {/* begin:: Drawers */}
      <ActivityDrawer />
      <RightToolbar />
      <DrawerMessenger />
      {/* end:: Drawers */}

      {/* begin:: Modals */}
      <InviteUsers />
      <UpgradePlan />
      {/* end:: Modals */}
      <ScrollTop />
    </PageDataProvider>
  );
};

export { ResponsiveLayoutWrapper };
